import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Lock, Crown, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';

const LimitReachedModal = ({ 
  isOpen, 
  onClose, 
  type = 'programs', // 'programs' or 'athletes'
  currentCount,
  limit
}) => {
  const isPrograms = type === 'programs';
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="limit-reached-modal">
        <DialogHeader>
          <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-4">
            <Lock className="h-8 w-8 text-amber-600" />
          </div>
          <DialogTitle className="text-center text-xl">
            {isPrograms ? 'Program' : 'Athlete'} Limit Reached
          </DialogTitle>
          <DialogDescription className="text-center text-gray-600 mt-2">
            You've reached the maximum of <span className="font-semibold text-gray-900">{limit} {isPrograms ? 'programs' : 'athletes'}</span> on the Free plan.
          </DialogDescription>
        </DialogHeader>

        <div className="my-6">
          <div className="bg-gradient-to-r from-purple-50 to-indigo-50 rounded-lg p-4 border border-purple-100">
            <div className="flex items-center space-x-2 mb-3">
              <Crown className="h-5 w-5 text-purple-600" />
              <h4 className="font-semibold text-purple-900">Upgrade to Pro</h4>
            </div>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-center space-x-2">
                <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />
                <span><strong>Unlimited</strong> programs</span>
              </li>
              <li className="flex items-center space-x-2">
                <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />
                <span><strong>Unlimited</strong> athletes</span>
              </li>
              <li className="flex items-center space-x-2">
                <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />
                <span>Team collaboration</span>
              </li>
              <li className="flex items-center space-x-2">
                <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />
                <span>Full attendance history</span>
              </li>
              <li className="flex items-center space-x-2">
                <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />
                <span>CSV exports</span>
              </li>
            </ul>
            <div className="mt-4 text-center">
              <p className="text-sm text-gray-600">
                Starting at just <span className="font-bold text-purple-700">$5/month</span>
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button 
            variant="outline" 
            className="flex-1"
            onClick={onClose}
            data-testid="limit-modal-close"
          >
            Maybe Later
          </Button>
          <Link to="/subscription" className="flex-1" onClick={onClose}>
            <Button 
              className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700"
              data-testid="limit-modal-upgrade"
            >
              <Zap className="h-4 w-4 mr-2" />
              Upgrade Now
            </Button>
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LimitReachedModal;
